var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13Z",
    fill: "#00CC99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7354 6.49698C1.7354 6.18173 1.90115 5.90548 2.1449 5.74298L6.2659 2.48648C6.65265 2.17773 7.21815 2.24598 7.52365 2.63273C7.8324 3.01948 7.76415 3.58498 7.3774 3.89048L5.2194 5.59998L10.3642 5.59998C10.8614 5.59998 11.2644 5.99973 11.2644 6.49698C11.2644 6.99423 10.8614 7.39723 10.3642 7.39723L5.21615 7.39723L7.37415 9.10673C7.7609 9.41223 7.82915 9.97448 7.5204 10.3645C7.2149 10.7512 6.6494 10.8195 6.26265 10.5107L2.1449 7.25098C1.90115 7.08848 1.7354 6.81223 1.7354 6.49698Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.d895e8824c424b01034c4230cfea7291.svg";
export { ForwardRef as ReactComponent };